import { Button } from "antd"
import styled from "styled-components"

const AppleButtonWrapper = styled.div`
  .apple-signin-button {
    display: flex
    align-items: center
    justify-content: center
    background-color: white
    border: 1px solid #ccc
    border-radius: 15px
    width: 200px
    height: 32px
    cursor: pointer
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif
  }

  .apple-logo {
    height: 16px
    margin-right: 8px
    fill: black
  }

  .apple-text {
    font-size: 13px
    color: black
  }
`

export const AppleButton = (props: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <AppleButtonWrapper {...props}>
      <Button
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '5px',
          fontWeight: 500,
          color: 'black',
          border: '1px solid black',
          borderRadius: 8,
          padding: '10px',

          height: '40px',
          width: '183px',
        }}
      >
        <div
          style={{
            paddingTop: -5,
          }}
        >
          <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.162 2.98931C10.8702 2.1586 11.2219 1.08531 11.1415 0C10.0724 0.110873 9.08482 0.617978 8.37593 1.42004C8.0289 1.81135 7.76328 2.26694 7.59438 2.76058C7.42548 3.25421 7.35663 3.77613 7.39179 4.29629C7.92584 4.30162 8.45417 4.1868 8.93711 3.96044C9.42005 3.73408 9.84504 3.40206 10.1802 2.98931" fill="#2C1338"></path><path d="M12.2409 9.62632C12.2507 8.94062 12.4349 8.26849 12.7764 7.67237C13.118 7.07625 13.6058 6.57548 14.1945 6.21658C13.8203 5.68688 13.3268 5.25109 12.7533 4.94384C12.1797 4.63659 11.5418 4.46635 10.8904 4.44664C9.50056 4.29914 8.15444 5.27087 7.44642 5.27087C6.7384 5.27087 5.63266 4.45965 4.46136 4.48134C3.70194 4.50694 2.96207 4.72687 2.31348 5.11983C1.6649 5.51278 1.12962 6.06541 0.759537 6.72414C-0.84007 9.47449 0.35308 13.5133 1.88713 15.7387C2.65634 16.8232 3.55229 18.0422 4.72359 17.9988C5.89489 17.9555 6.29698 17.27 7.68243 17.27C9.06788 17.27 9.46123 17.9988 10.6544 17.9685C11.8475 17.9381 12.6604 16.8753 13.3991 15.7777C13.9511 15.0032 14.376 14.1466 14.6578 13.24C13.9421 12.9395 13.3314 12.4366 12.9016 11.794C12.4719 11.1515 12.2421 10.3976 12.2409 9.62632Z" fill="#2C1338"></path></svg>
        </div>
        {props.children}
      </Button>
    </AppleButtonWrapper>
  )
}
